import React, { Component } from 'react';
import { UploadPanel } from "../components";
import { constant } from "../helpers";
import './Site.css';
import {Redirect} from "react-router-dom";

export default class ShippingHistoryUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToShippingSummary: false
        }
    }

    render() {
        if (this.state.redirectToShippingSummary){
            return (<Redirect to="/sales_summary" />);
        }

        return (
            <div>
                <UploadPanel
                    uploadType={constant.uploadType.shippingHistorical}
                    onSuccess={() => this.setState({redirectToShippingSummary: true})}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ShippingHistoryUpload.js